import { xlCol, xlColq } from '../../common/constants'

/* ===========================
 * Trip List Table
 * =========================== */

export const planHeaders = [
  {
    header: '',
    field: 'select',
    xlCol,
    weight: 35,
    align: 'center',
  },
  {
    header: 'Vehicle No',
    field: 'VehicleNo',
    xlCol,
    weight: 110,
    align: 'center',
    showfilter: true,
  },
  {
    header: 'Live Trip ID',
    field: 'TripID',
    xlCol,
    weight: 90,
    align: 'center',
    showfilter: true,
  },
  {
    header: 'Trip Date-Time',
    field: 'TripDateView',
    xlCol,
    weight: 120,
    showfilter: true,
  },
  {
    header: 'Trip Name | Middle Cities',
    field: 'TripName',
    xlCol: xlColq,
    weight: 260,
  },
  {
    header: 'Total Weight Capacity (KG)',
    field: 'TotalCapacity',
    xlCol,
    weight: 120,
    align: 'center',
  },
  {
    header: 'Utilized Capacity (KG)',
    field: 'UtilizedWeight',
    xlCol,
    weight: 120,
    align: 'center',
  },
  {
    header: 'Available Capacity (KG)',
    field: 'AvailableCapacity',
    xlCol,
    weight: 120,
    align: 'center',
  },
  {
    header: 'Utilization %',
    field: 'UtilizationPer',
    xlCol,
    weight: 90,
    align: 'center',
  },
  {
    header: 'View Load',
    field: 'ViewLoad',
    xlCol,
    weight: 70,
    align: 'center',
    ViewOnly: true,
  },
]

/* ===========================
 * LR Table
 * =========================== */
export const tripTableColumns = [
  {
    headerName: 'Vehicle No',
    field: 'VehicleNo',
    xlCol,
    weight: 25,
    align: 'center',
  },
  {
    headerName: 'Live Trip ID',
    field: 'TripID',
    xlCol,
    weight: 20,
    align: 'center',
  },
  {
    headerName: 'Trip Date-Time',
    field: 'TripDateView',
    xlCol,
    weight: 35,
    align: 'center',
  },
  {
    headerName: 'Trip Name | Middle Cities',
    field: 'tripRoute',
    xlCol,
    weight: 80,
    align: 'left',
  },
  {
    headerName: 'Total Weight Capacity (KG)',
    field: 'TotalCapacity',
    xlCol,
    weight: 30,
    align: 'center',
  },
  {
    headerName: 'Utilized Capacity (KG)',
    field: 'UtilizedCapacity',
    xlCol,
    weight: 30,
    align: 'center',
  },
  {
    headerName: 'Available Capacity (KG)',
    field: 'AvailableCapacity',
    xlCol,
    weight: 30,
    align: 'center',
  },
  {
    headerName: 'Utilization In %',
    field: 'UtilizationPct',
    xlCol,
    weight: 25,
    align: 'center',
  },
]
export const lrHeaders = [
  {
    header: '',
    field: 'select',
    xlCol,
    weight: 70,
    align: 'center',
  },
  {
    header: 'LR No',
    field: 'LRNO',
    xlCol,
    weight: 130,
    align: 'left',
    showfilter: true,
  },
  {
    header: 'Source City',
    field: 'SourceCity',
    xlCol,
    weight: 100,
    showfilter: true,
  },
  {
    header: 'Source Branch',
    field: 'SourceBranch',
    xlCol,
    weight: 130,
    showfilter: true,
  },
  {
    header: 'Destination City',
    field: 'DestinationCity',
    xlCol,
    weight: 100,
    showfilter: true,
  },
  {
    header: 'Destination Branch',
    field: 'DestinationBranch',
    xlCol,
    weight: 130,
    showfilter: true,
  },
  {
    header: 'Since Days',
    field: 'SinceDays',
    xlCol,
    weight: 80,
    align: 'center',
    red: true,
    showfilter: true,
  },
  {
    header: 'Since Date',
    field: 'SinceDateShow',
    xlCol,
    weight: 100,
    align: 'center',
    red: true,
    showfilter: true,
  },
  {
    header: 'Total Units',
    field: 'Items',
    xlCol: xlColq,
    weight: 80,
    align: 'right',
  },
  {
    header: 'Actual Weight (KG)',
    field: 'Weight',
    xlCol: xlColq,
    weight: 110,
    align: 'right',
  },
  {
    header: 'Freight',
    field: 'Freight',
    xlCol: xlColq,
    weight: 90,
    align: 'right',
  },
  {
    header: 'Other Charge',
    field: 'OtherCharges',
    xlCol: xlColq,
    weight: 100,
    align: 'right',
  },
  {
    header: 'GST',
    field: 'GST',
    xlCol: xlColq,
    weight: 80,
    align: 'right',
  },
  {
    header: 'Total Amount',
    field: 'TotalAmount',
    xlCol: xlColq,
    weight: 110,
    align: 'right',
  },
]

/* ===========================
 * Summary Cards
 * =========================== */

export const summaryCards = [
  {
    key: 'totalCapacity',
    title: 'Total Capacity',
    unit: 'KG',
    color: '#07883d',
    bg: '#eef9f1',
    icon: 'Balance',
  },
  {
    key: 'utilizedCapacity',
    title: 'Utilized Capacity',
    unit: 'KG',
    color: '#4c16c9',
    bg: '#f1edff',
    icon: 'Inventory2Outlined',
  },
  {
    key: 'utilization',
    title: 'Utilization (Overall)',
    unit: '%',
    color: '#4b19cb',
    bg: '#f2efff',
    icon: 'PieChartOutline',
  },
  {
    key: 'availableCapacity',
    title: 'Available Capacity',
    unit: 'KG',
    color: '#f05a00',
    bg: '#fff3ea',
    icon: 'PieChart',
  },
]
